<template>
  <!-- Mobile -->
  <v-app-bar
    flat
    outlined
    :color="$store.state.fullConfig.theme.colors.mlt.brown"
  >
    <v-app-bar-nav-icon @click.stop="SET_DRAWER()"></v-app-bar-nav-icon>
    <v-toolbar-title>
      <a href="/" :title="$store.state.globals.title">{{ $store.state.globals.title }}</a>
    </v-toolbar-title>
  </v-app-bar>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';

// Removed the class `mdc-top-app-bar` because it has dflex in its CSS. TailwindCSS's lg:hidden has less priority in the CSS chain. Couldn't remove dflex from the source because it is coming from the source code. `text-white` to `w-full` are used instead of `mdc-top-app-bar`
export default {
  name: "TopAppBar",

  computed: {
    ...mapState({
      axiosWc: 'axiosWc'
    }),
    ...mapGetters(['getUrlApi','getBrands']),
  },

  watch: {},

  created() {
  },

  mounted: async function () {
  },

  data: function () {
    return {
    };
  },

  methods: {
    ...mapMutations({
      SET_DRAWER: "SET_DRAWER",
    }),
  },
};
</script>

<style lang="scss">
.theme--light.v-btn.v-btn--icon,
.v-toolbar__title a {
  color: #fff !important;
}
</style>